module.exports = __webpack_public_path__ + "img/coal.b5567f06.png";